// extracted by mini-css-extract-plugin
module.exports = {"container":"Signup_container__-5IfP"};